import Controller from "../../../../core/js/Controller";

export default class Transfers extends Controller {
    constructor() {
        super();
    }

    filterTransfers(e, el) {
        e.preventDefault();

        this.filters.querySelector('.radio.active').removeClass('active');
        el.addClass('active');

        this.list.querySelectorAll('.transfer-card').forEach((item) => {
            item.removeClass('force-hidden');

            switch (el.dataset.filter) {
                case 'income':
                    if (item.dataset.type !== '1') {
                        item.addClass('force-hidden');
                    }

                    break;

                case 'outcome':
                    if (item.dataset.type !== '0') {
                        item.addClass('force-hidden');
                    }

                    break;
            }
        });
    }

    changeWindow(e) {
        this.windowForm.submit();
    }
}